export const BOOKING_URL = "https://nirva.instituteofhypnotherapy.com/";

export const STATUS_CHIP_STYLES = {
  base: {
    fontWeight: 600,
    px: 2,
    height: 28,
    fontFamily: "'Gotham', sans-serif",
    "& .MuiChip-label": { px: 1 },
    "@media (max-width:600px)": {
      height: 24,
      px: 1,
      fontSize: 10,
      "& .MuiChip-label": { px: 0.5 },
    },
  },
  confirmed: { bgcolor: "#4CAF50", color: "white" },
  cancelled: { bgcolor: "#F44336", color: "white" },
  rescheduled: { bgcolor: "#9C27B0", color: "white" },
  pending: { bgcolor: "#FF9800", color: "white" },
  completed: { bgcolor: "#2196F3", color: "white" },
  showed: { bgcolor: "#2196F3", color: "white" },
  noshow: { bgcolor: "#9E9E9E", color: "white" },
  past: { bgcolor: "transparent", color: "#666", border: "1px solid #666" },
};

export const DEFAULT_HOURLY_RATE = 150;

export const EMPTY_STATE_TYPES = {
  PRACTITIONER_NO_APPOINTMENTS: "practitionerNoAppointments",
  PRACTITIONER_NO_PAST_APPOINTMENTS: "practitionerNoPastAppointments",
  NOT_REGISTERED: "notRegistered",
  PATIENT_NO_APPOINTMENTS: "patientNoAppointments",
};

export const AGREEMENT_BANNER = {
  TITLE: "Client Participation Agreement Required",
  SUBTITLE: "Please sign the agreement before booking follow-up sessions.",
  BUTTON_TEXT: "Sign Agreement",
};

export const TELEHEALTH_BANNER = {
  TITLE: "Telehealth Informed Consent Required",
  SUBTITLE:
    "Please review and sign the Telehealth Informed Consent before booking follow-up sessions.",
  BUTTON_TEXT: "Sign Telehealth Consent",
};
